/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { StandaloneSliderSlide as ResolvedStandaloneSliderSlide } from 'base/components/standalone/Slider/Slide';

export const SliderSlide: typeof ResolvedStandaloneSliderSlide = withStandaloneInstanceof((props) => {
    return (
        <ErrorBoundary>
            <ResolvedStandaloneSliderSlide {...props} />
        </ErrorBoundary>
    );
});

export type SliderSlideProps = PropsFromComponent<typeof SliderSlide>;

/** @deprecated Use slot architecture instead */
export const SliderSlideWith = (extras: DynamicStandaloneExtras): typeof SliderSlide => {
    return function SliderSlide(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'SliderSlide');
        return <ResolvedStandaloneSliderSlide {...mergeProps({ options: { theme } }, props)} />;
    }
}